            /*  comment  %}
            - Builds a cart item object from the given product form
            - @param {HTMLFormElement} form - The product form element

            - @returns {Object} - An object containing the line item details and the key of product to be removed
            {% endcomment %} */
            function buildPreupsellPayload(form) {
                const formData = new FormData(form);

                return {
                    productTokenKey: formData.get('product-token-key'),
                    items: [
                        {
                            id: Number(formData.get('id')),
                            selling_plan: formData.get('selling_plan'),
                            quantity: Number(formData.get('quantity')),
                            properties: {
                                _selling_plan: formData.get('selling_plan'),
                                _selling_plan_name: formData.get('selling_plan_name'),
                                _line_item_id: formData.get('line-item-id'),
                                _free_gift_info: formData.get('free_gift_info'),
                                _subscription_terms: formData.get('properties[_subscription_terms]'),
                                _supplement_terms: formData.get('properties[_supplement_terms]'),
                                _promo_text: formData.get('promo-text'),
                                _pricebook: formData.get('pricebook'),
                                _product_from_PDP: formData.get('product-from-PDP'),
                                _from_sas: formData.get('from-sas')
                            }
                        }
                    ]
                };
            }

            /*{%  comment  %}
            - Function to add product to cart
            - @param {Array} items - details of the product to be added

            - @returns {Object} - An object containing status of the function
            {%  endcomment  %}*/
            async function preupsellAddToCart(payload) {
                try {
                    const response = await fetch('/cart/add.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Operation-Type': 'prepurchase-upgrade'
                        },
                        body: JSON.stringify({items: payload, attributes: { "_preupsell_product_token": "" }})
                    });

                    if (!response.ok) {
                        throw new Error('Failed to add to cart');
                    }

                    const data = await response.json();
                    return { success: true, data };
                } catch (error) {
                    console.error('preupsellAddToCart(): Add to cart error', error);
                    return { success: false, error };
                }
            }

            /*{%  comment  %}
            - Function to remove the qualifying product from cart and add the upsell product to cart
            - @param {Object} data - includes the key of qualifying product to be removed and details of upsell product to be added

            - @returns {Object} - An object containing status of the function
            {%  endcomment  %}*/
            async function initiatePreupsellUpgrade(data) {
                if(!data.productTokenKey || !data.items) return;

                try {
                    const response = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            id: data.productTokenKey,
                            quantity: 0
                        })
                    });

                    if (!response.ok) {
                        throw new Error('Failed to remove product');
                    }

                    const addToCartResult = await preupsellAddToCart(data.items);
                    return addToCartResult;
                } catch (error) {
                    console.error('initiatePreupsellUpgrade(): error', error);
                    return { success: false, error };
                }
            }

            // Find the upgrade button and add click event listener for implementing preupsell logic
            //updating to querySelectorAll to work for the sticky footer, and putting in try/catch because apparently this is called multiple times
            try{
                const preupsellUpgradeButtons = document.querySelectorAll('.preupsell-upgrade');
                if(preupsellUpgradeButtons) {
                    preupsellUpgradeButtons.forEach((preupsellUpgradeButton) => {
                        preupsellUpgradeButton.addEventListener('click', async (event) => {
                            preupsellUpgradeButton.disabled = true;
                            
                            const preupsellProductForm = document.querySelector('#preupsell-product-form');
                            if(!preupsellProductForm) {
                                console.warn("no qualifying preupsell product form found");
                                return;
                            }

                            // Build the payload for performing upsell logic from upsell product form data
                            const preupsellPayload = buildPreupsellPayload(preupsellProductForm);
                            // Initiate the upsell logic 
                            const result = await initiatePreupsellUpgrade(preupsellPayload);
                            // If upsell is successfull, proceed to checkout page.
                            if (result.success) {
                                preupsellUpgradeButton.disabled = true;
                                window.location.replace("/checkout");
                            } else { // If upsell failed, redirect to homepage.
                                console.warn('Preupsell upgrade failed:', result.error);
                                //window.location.replace("/"); COMMENTING THIS OUT BECAUSE IT'S THROWING FALSE FAILURES DURING DELAYS IN BROWSERSTACK
                                window.location.replace("/checkout");
                            }
                        })
                    });
                }
            }catch(e){}